import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { TodoItems } from '../../helpers/schema';

export const schema = z.object({
  todoId: z.string().min(1),
  title: z.string().optional(),
  description: z.string().optional().nullable(),
  isCompleted: z.boolean().optional(),
  dueDate: z.date().optional().nullable(),
  position: z.number().optional(),
  ambiguous: z.boolean().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  todo: Selectable<TodoItems>;
};

export const updateTodo = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/todos/update`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
